// Legacy fields have a label point, not an inferred perimeter. Fit their actual
// lots/zones together so adding that label does not zoom into just one of them.
export const fieldFitGeometry = (feature, features = []) => {
  if (feature?.properties?.resource_type !== 'field' || feature?.geometry?.type !== 'Point') {
    return feature?.geometry
  }

  const {field_id, company_id} = feature.properties
  const children = features.filter((child) =>
    ['land', 'gap'].includes(child?.properties?.resource_type) &&
    child.properties.field_id === field_id &&
    child.properties.company_id === company_id &&
    ['Polygon', 'MultiPolygon'].includes(child?.geometry?.type)
  )

  return children.length ? {type: 'FeatureCollection', features: children} : feature.geometry
}
